<ng-template #step1>
  <div class="dialog__body dialog__body--no-padding dialog__body--grow dialog__body--grey">
    <div class="dialog__inner">
      <h3 class="dialog__sub-heading">{{ "Selfservice.Global.Title" | translate }}</h3>
      <p class="no-margin">{{ "Selfservice.DDOS.Text" | translate }}</p>
    </div>

    <div class="dialog__rule">
      <h3 class="dialog__sub-heading">{{ "Selfservice.Global.CurrentSetting" | translate }} DDoS filter</h3>
      <div class="dialog__rule-answer">{{ filterStatus() | enabled_or_value }}</div>
    </div>
    <div class="dialog__rule">
      <h3 class="dialog__sub-heading">{{ "Selfservice.Global.NewSetting" | translate }} DDoS filter</h3>
      <div class="dialog__rule-answer blue">{{ !filterStatus() | enabled_or_value }}</div>
    </div>
  </div>
</ng-template>

<selfservice-wizard [steps]="[step1]" [getCommand]="buildCommand" [bus]="bus()" />
